module.exports = __webpack_public_path__ + "static/media/sensor_icon.d82c0b0a.svg";